module.exports = __webpack_public_path__ + "img/5.6e9358fa.jpg";